
import React from "react";

interface FrameIconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const FrameIcon = ({ size = 24, strokeWidth = 2, className = "" }: FrameIconProps) => {
  // Fix the viewBox to maintain proper proportions
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ minWidth: `${size}px`, minHeight: `${size}px` }} // Force exact dimensions
    >
      <rect x="4" y="4" width="6" height="6" />
      <rect x="14" y="4" width="6" height="6" />
      <rect x="4" y="14" width="6" height="6" />
      <rect x="14" y="14" width="6" height="6" />
    </svg>
  );
};

export default FrameIcon;
